// extracted by mini-css-extract-plugin
export default {"heading-primary":"Disclaimer_heading-primary__BYTrz","disclaimer":"Disclaimer_disclaimer__+U21D","disclaimer--info":"Disclaimer_disclaimer--info__yVUk6"};